import { Component, Inject, OnInit } from '@angular/core';
// import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ButtonData } from '../buttons/buttons.component';

export interface CardExtraInfoData {
  description: string;
  category: string;
  title: string;
}

export interface TabsCardsData {
  description: string;
  extraInfo: Array<any>;
  title: string;
}
export interface TabsSectionCardData {
  title: string;
  description: string;
}

export interface TabsSectionCardsData {
  subtitle: string;
  title: string;
  cards: Array<TabsSectionCardData>;
}

export interface ModalTabsData {
  id: string;
  cards: Array<TabsCardsData>;
  sections: Array<TabsCardsData>;
  components: Array<any>;
  category: string;
  color: string;
  group: string;
  title: string;
  description: string;
}

export interface ModalData {
  title: string;
  titleTabs: string;
  subtitleTabs: string;
  img: string;
  components: Array<any>;
  documents: Array<any>;
  type: string;
  iframe: any;
  data: Array<any>;
  tabs: Array<ModalTabsData>;
  text: string;
  buttons: Array<ButtonData>;
  idTab?: string;
}

@Component({
  selector: 'fcp-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements OnInit {
  public item: ModalData;

  constructor(public bsModalRef: BsModalRef) {}

  ngOnInit() {
    if (this.item?.text) {
      this.item.text = this.item.text
        .replace(/<table/gi, '<div class="responsive-table"><table')
        .replace(/<\/table>/gi, '</table></div>');
    }
  }

  close() {
    this.bsModalRef.hide();
  }

  getPageIncUrl(components) {
    return components && components[0] ? components[0].iframe : '';
  }
}
